import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import "css/main.css";
import "css/style.css";
import "external/fontawesome/css/all.css";

import config from "config.json";
import { recoverPass } from "services/auth_service";

function App({ setActiveTab }) {
  const { t } = useTranslation();

  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [email, setEmail] = useState("");
  const [canSubmitRecover, setCanSubmitRecover] = useState(true);

  const changeEmail = (evt) => {
    setEmail(evt.target.value);
  };

  const canSubmitRecoverFunc = () => {
    const EMAIL_REGEX_VAL = new RegExp(config.EMAIL_REGEX_VALIDATOR, "i");
    return canSubmitRecover && EMAIL_REGEX_VAL.test(email) ? true : false;
  };

  const changeTab = () => {
    setActiveTab("login");
  };

  const submitRecover = async () => {
    try {
      setCanSubmitRecover(false);
      await recoverPass(email);
      setSuccessMsg(t("SUCCESS_password_recover"));
      setErrorMsg("");
    } catch (exception) {
      setErrorMsg(t("ERROR_unexpected_confirm_data"));
      setSuccessMsg("");
    }
  };

  return (
    <div className="App">
      <section className="section" style={{ padding: "0" }}>
        <div className="block">
          <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to={"/login"} onClick={() => changeTab("login")}>
                  Login
                </Link>
              </li>
              <li className="is-active">
                <Link to={"/login"} aria-current="page">
                  {t("recover_password")}
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="block">
          <h3 className="title is-4">{t("email_for_recovery")}</h3>
          <p></p>
        </div>

        <div className="block">
          <div className="field">
            <p className="control has-icons-left has-icons-right">
              <input
                className="input"
                type="email"
                value={email}
                onChange={changeEmail}
                placeholder="Email"
              />
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
            </p>
          </div>
        </div>

        <div className="block">
          <button
            className="button btn1 is-link is-fullwidth"
            type="submit"
            onClick={submitRecover}
            disabled={!canSubmitRecoverFunc()}
          >
            {t("send")}
          </button>
        </div>

        {successMsg !== "" && (
          <div className="block">
            <article className="message is-success">
              <div className="message-body">{successMsg}</div>
            </article>
          </div>
        )}

        {errorMsg !== "" && (
          <div className="block">
            <article className="message is-warning">
              <div className="message-body">{errorMsg}</div>
            </article>
          </div>
        )}
      </section>
    </div>
  );
}

export default App;
